import { ErrorResponse } from '@src/interface/api/response.interface'
import {
	getVendorProductDetail,
	GetVendorProductDetailResponse,
} from '@src/lib/api/product/getVendorProductDetail'
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type ParamTypes = {
	productNo: string
}
const useGetVendorProductDetailQuery = (
	{ productNo }: ParamTypes,
	options: UseQueryOptions<
		GetVendorProductDetailResponse,
		AxiosError<ErrorResponse>,
		GetVendorProductDetailResponse,
		string[]
	>,
): UseQueryResult<GetVendorProductDetailResponse, AxiosError<ErrorResponse>> => {
	return useQuery(createKey(productNo), () => getVendorProductDetail({ productNo }), {
		...options,
	})
}

const createKey = (productNo: string) => ['vendor-product-detail', productNo]

export default useGetVendorProductDetailQuery
